<div class="d-flex mt-2" [ngClass]="condensedView() ? 'border-0' : 'rounded border'">
    @if (!condensedView()) {
        <div class="rounded-start" [ngClass]="takeColorClass(true)">&nbsp;</div>
    }
    <div class="d-flex w-100">
        <!-- Status bar -->
        <div class="d-flex flex-column ms-2" [ngClass]="condensedView() ? 'mt-1' : 'mt-3'">
            @if (!notification.IsRead) {
                <i class="fa-solid fa-circle fa-xs mt-2 mx-auto px-auto" [ngClass]="takeColorClass(false)"></i>
            }
        </div>

        <div class="w-100">
            @if (notification) {
                @if (isWindowClosed(notification.Notification)) {
                    <blockgroup-window-closed-notifiaction
                        [notification]="notification.Notification"
                        [condensedView]="condensedView()"
                        (notificationRead)="readNotification()"
                    ></blockgroup-window-closed-notifiaction>
                }
                @if (isWindowOpened(notification.Notification)) {
                    <blockgroup-window-opened-notifiaction
                        [notification]="notification.Notification"
                        [condensedView]="condensedView()"
                        (notificationRead)="readNotification()"
                    ></blockgroup-window-opened-notifiaction>
                }
                @if (isLearnerBulkImportComplete(notification.Notification)) {
                    <lib-learner-bulk-import-complete
                        [notification]="notification.Notification"
                        [condensedView]="condensedView()"
                        (notificationRead)="readNotification()"
                    ></lib-learner-bulk-import-complete>
                }
                @if (isFacultyBulkImportComplete(notification.Notification)) {
                    <lib-faculty-bulk-import-complete
                        [condensedView]="condensedView()"
                        [notification]="notification.Notification"
                        (notificationRead)="readNotification()"
                    ></lib-faculty-bulk-import-complete>
                }
            }
        </div>

        @if (notification.IsActive) {
            <div class="d-flex flex-column ms-2 me-3" [ngClass]="condensedView() ? 'mt-1' : 'mt-3'">
                <i
                    class="fal fa-times fa-lg text-grey-600 mt-2 clickable mx-auto px-auto"
                    (click)="onDeleteClick()"
                ></i>
            </div>
        }
    </div>
</div>
